import React, { useState } from "react";
import { HStack, Text, Box } from "@chakra-ui/react";
import { COLORS } from "../../../Helper/Colors";
import { Lock } from "phosphor-react";
import { ProfileDetailsItem } from "./ProfileDetailsItem";
import { ModalComponent } from "../UI";
import ChangePassword from "./ChangePassword";
import placeHolder from "../../../Assets/profile_placeholder.jpg";

export const ProfileDetails = ({ profileData }) => {
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
  const handelChangePassword = () => {
    setIsChangePasswordOpen(true);
  };
  const handelChangePasswordClose = () => {
    setIsChangePasswordOpen(false);
  };

  return (
    <>
      <Box marginTop={"25px"} padding={4} borderRadius="lg" width={"100%"}>
        <ModalComponent
          isOpen={isChangePasswordOpen}
          onClose={handelChangePasswordClose}
          size={"lg"}
        >
          <ChangePassword onClose={handelChangePasswordClose} />
        </ModalComponent>
        <Text color={COLORS.dark} fontSize="xl" fontWeight={"medium"}>
          Personal Information
        </Text>
        <Box
          marginTop={"25px"}
          border={"1px solid"}
          borderColor={COLORS.gray}
          padding={4}
          borderRadius="lg"
          width={"100%"}
        >
          <HStack spacing="3" marginTop={5} marginLeft={"6"}>
            <ProfileDetailsItem
              label="First Name"
              value={profileData?.firstName || " - "}
            />
            <ProfileDetailsItem
              label="Last Name"
              value={profileData?.lastName || " - "}
            />
            <ProfileDetailsItem
              label="Email"
              value={profileData?.email || " - "}
            />
          </HStack>
          <HStack
            spacing="8"
            alignItems={"start"}
            marginTop={"20px"}
            marginLeft={"6"}
          >
            <ProfileDetailsItem
              label="Profile Photo"
              type="image"
              value={profileData?.profilePhoto || placeHolder}
            />
          </HStack>
          <HStack
            alignItems={"center"}
            marginTop={10}
            color={COLORS.brand}
            cursor={"pointer"}
            fontSize={16}
            fontWeight={500}
            _hover={{ textDecoration: "underline" }}
            onClick={handelChangePassword}
            marginBottom={"30px"}
            marginLeft="6"
          >
            <Lock size={18} color={COLORS.brand} weight="bold" />
            <Text>Change Password</Text>
          </HStack>
        </Box>
      </Box>
    </>
  );
};
